import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PageSource } from 'src/model/enum/enums';
import { WordList } from 'src/model/WordList';

interface ChallengeState {
    autoPlay: boolean;
    selectedLists: WordList[];
    isFiltered: boolean;
    pageSource: PageSource;
    // ... other challenge state properties
}

const initialState: ChallengeState = {
    autoPlay: true,
    selectedLists: [],
    isFiltered: false,
    pageSource: PageSource.Challenge,
    // ... other initial state properties
};

const challengeSlice = createSlice({
    name: 'challenge',
    initialState,
    reducers: {
        setAutoPlay: (state, action: PayloadAction<boolean>) => {
            state.autoPlay = action.payload;
        },
        setSelectedLists: (state, action: PayloadAction<WordList[]>) => {
            state.selectedLists = action.payload;
        },
        setIsFiltered: (state, action: PayloadAction<boolean>) => {
            state.isFiltered = action.payload;
        },
        setPageSource: (state, action: PayloadAction<PageSource>) => {
            state.pageSource = action.payload;
        },
        // ... other reducers
    }
});

export const challengeActions = challengeSlice.actions;

export default challengeSlice.reducer;
